import * as React from "react";
import BurgerMenuDesktop from "./BurgerMenuDesktop";
import BurgerMenuMobile from "./BurgerMenuMobile";
import { showMobile } from "helpers/adaptation";

export interface BurgerMenuProps {
  viewOpenLeftMenu?: boolean;
  handleClickCloseLeftMenu?: () => void;
}

const BurgerMenu = (props: BurgerMenuProps) => {

  return (
    <>
      {!showMobile && <BurgerMenuDesktop {...props} />}
      {showMobile && <BurgerMenuMobile {...props} />}
    </>
  );
};

export default BurgerMenu;
